import { createSelector } from 'reselect'

export const getNotifications = state => state.notifications

export const getErrorNotification = createSelector(
    getNotifications,
    notifications => notifications.error,
)

export const hasErrorNotification = createSelector(
    getErrorNotification,
    errorNotification => errorNotification !== null,
)

export const getErrorNotificationMessage = createSelector(
    getErrorNotification,
    errorNotifications => errorNotifications !== null ? errorNotifications.message : '',
)

export const getAlerts = createSelector(
    getNotifications,
    notifications => notifications.alerts,
)
